import api from "@/api";
import { NoticeModel, PageModel, PaginationModel } from "../types";

export default class NoticeApi {
  static async list(
    options:
      | {
          filter?: {
            role?: string[];
          };
        }
      | PaginationModel
  ): Promise<PageModel<NoticeModel>> {
    return await api.get(`notice`, options);
  }

  static async single(id: string) {
    return await api.get(`notice/${id}`);
  }

  static async create(data: {}) {
    return await api.post(`notice`, data);
  }

  static async update(data: {}) {
    return await api.put(`notice`, data);
  }

  static async delete(id: string) {
    return await api.del(`notice/${id}`);
  }
}
